<template>
  <div id="app">
    <Countdown endYear="2022" endMonth="4" endDay="23" endHour="18" endMinute="30" isUTC/>
  </div>
</template>

<script>
import Countdown from './components/Countdown.vue'

export default {
  name: 'app',
  components: {
    Countdown
  }
}
</script>

<style lang="scss">
html {
  background: #000;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  margin-top: 60px;
}
</style>
